import React, { useEffect, useCallback, useMemo } from 'react';
import { GECKO_CONSTS, GeckoField } from 'ui';

const ENVIRONMENT_OPTIONS = [
  { label: 'Live', value: 'live' },
  { label: 'Sandbox', value: 'sandbox' },
];

const DEFAULT_ENVIRONMENT = 'live';

const ENVIRONMENT_FIELD = {
  key: 'value',
  label: 'Environment',
  description:
    'Choose the Salesforce environment you would like to integrate with',
  type: GECKO_CONSTS.FIELD_TYPE_SELECT,
  options: ENVIRONMENT_OPTIONS,
};

const SalesforceEnvironmentField = ({ value, setValue }) => {
  useEffect(() => {
    if (!value) {
      setValue(DEFAULT_ENVIRONMENT);
    }
  }, [value]);

  const changeHandler = useCallback(
    (_key, value) => {
      setValue(value);
    },
    [setValue]
  );

  const values = useMemo(() => {
    return { value };
  }, [value]);

  return (
    <div className="SalesforceEnvironmentField">
      <GeckoField
        field={ENVIRONMENT_FIELD}
        handler={changeHandler}
        values={values}
      />
    </div>
  );
};

export default SalesforceEnvironmentField;
